import React from 'react';
import { usePageMeta } from '../../hooks/usePageMeta';
import { PageHero } from '../../components/ui/PageHero';
import { Section } from '../../components/ui/Section';
import { ActionLink } from '../../components/ui/ActionLink';
import { TextLink } from '../../components/ui/TextLink';
import { StepList } from '../../components/ui/StepList';
import { BenefitList } from '../../components/ui/BenefitList';
import { TeacherList } from '../../components/ui/TeacherList';
import { EnquirySection } from '../../components/forms/EnquirySection';
import { lessonStages, levels, progressChecks } from '../../data/pageContent';
import { teachers } from '../../data/people';
import { images } from '../../data/images';
export function TeachingMethodology() {
  usePageMeta('Our English Teaching Method | Speak in Every Lesson | ES World', 'See how our English teaching method works. You speak in every lesson and get feedback every week. Try a free lesson.');
  return <>
      <PageHero breadcrumbs={[{
      label: 'About Us',
      to: '/about/who-we-are'
    }, {
      label: 'Teaching Methodology',
      to: '/about/teaching-methodology'
    }]} title="Our English teaching method: learn it, use it, improve it" lead="Our English teaching method is simple: you learn new language, you use it in a real task, and your teacher helps you improve. Lessons are practical and personal. You speak from the first lesson, and you see your progress every week." primary={{
      label: 'Try a free lesson',
      to: '#enquire'
    }} secondary={{
      label: 'See our levels',
      to: '#levels'
    }} image={images.classroom} imageAlt="A teacher leading an active class" data-id="element-985" data-mp="6vw441hf6c6v" />

      <Section id="lessons" title="Every lesson has a clear path" subhead="Each lesson moves from new language to real use. You always know what you are learning and why." aside={<TextLink to="#teachers" data-id="element-987" data-mp="35e1e6t4s8rpx">Meet some of our teachers</TextLink>} data-id="element-986" data-mp="13kll7pl830rs">
        <StepList items={lessonStages} data-id="element-988" data-mp="chzua1m28vvw" />
        <div className="mt-12" data-id="element-989" data-mp="cj1g914m72se">
          <ActionLink to="#enquire" data-id="element-990" data-mp="7jyafegt8sjd">Take the free level test</ActionLink>
        </div>
      </Section>

      <Section id="levels" bg="cream" title="Know your level at every step" description="Our levels follow the CEFR scale. Each level takes about 12 weeks with 15 lessons a week, or 6 weeks with 30 lessons a week." data-id="element-991" data-mp="lj7rshgr5sox">
        <ol className="divide-y divide-line border-y border-line" data-id="element-992" data-mp="vfswf1ov11s8">
          {levels.map(level => <li key={level.name} className="grid gap-1 py-4 md:grid-cols-12 md:items-baseline md:gap-6" data-id="element-993" data-mp="qian3a6xkkjp">
              <span className="type-card-title text-ink md:col-span-4" data-id="element-994" data-mp="14c1uod13pucs">{level.name}</span>
              <span className="type-small font-bold text-ink md:col-span-1" data-id="element-995" data-mp="1095ip562gwht">{level.cefr}</span>
              <span className="md:col-span-7" data-id="element-996" data-mp="1e8enz9sqi670">{level.text}</span>
            </li>)}
        </ol>
      </Section>

      <Section id="progress" title="See your progress clearly" description="You never need to guess how you are doing. Regular checks show what you can do now and what comes next." data-id="element-997" data-mp="1977f17euv0yr">
        <BenefitList items={progressChecks} data-id="element-998" data-mp="1xt5dyhmqrkyw" />
      </Section>

      <Section id="teachers" bg="grey" title="Qualified teachers who listen" description="Our teachers hold qualifications such as CELTA, TESOL or a related degree. They observe each other and train every term." mockup="Sample teacher profiles" data-id="element-999" data-mp="1ixfsqlpdrbv8">
        <TeacherList items={teachers} data-id="element-1000" data-mp="1evax5hfdg55y" />
      </Section>

      <EnquirySection title="Try our method for free" description="Book a free trial lesson or a free level test. Tell us your goal, and we find the right class for you." submitLabel="Send my lesson request" data-id="element-1001" data-mp="1ewvu1dp5s06z" />
    </>;
}